document.addEventListener("DOMContentLoaded", (e) => {
  const flattenCartItems = (items = []) => {
    const cartItems = Array.isArray(items) ? items : [];

    return {
      productIds: cartItems.map((item) => item.product_id ?? item.id ?? "").join(","),
      productNames: cartItems
        .map((item) => item.product_title ?? item.title ?? "")
        .join(","),
      productQuantities: cartItems.map((item) => item.quantity ?? 0).join(","),
      productPrices: cartItems.map((item) => item.price ?? 0).join(","),
    };
  };

  const getLocalStorageValue = (key) => {
    try {
      return window.localStorage?.getItem(key) ?? null;
    } catch (_) {
      return null;
    }
  };

  const getDataLakeCommonDetails = async (eventname, data) => {
    let user = 0;
    const storedCustomer = getLocalStorageValue("customer");
    if (storedCustomer) {
      try {
        user = JSON.parse(storedCustomer);
      } catch (_) {
        user = 0;
      }
    }
    return {
      data: {
        events: [
          {
            _id: crypto.randomUUID() + "-" + crypto.randomUUID(),
            eventName: eventname,
            eventParams: data,
            createdAt: new Date().getTime(),
            eventId: crypto.randomUUID() + "-" + crypto.randomUUID(),
            userId: user ? user?.metafields?.cult?.cfuserid : 0,
            sessionId: data.sessionId,
          },
        ],
        user: user
          ? {
              createdAt: new Date().getTime(),
              userId: user?.metafields?.cult?.cfuserid,
              userParams: {
                userId: user?.metafields?.cult?.cfuserid,
                firstName: user?.firstName,
                lastName: user?.lastName,
                email: user?.metafields?.cult?.email,
                phone: user?.phone,
                userName: user?.firstName + " " + user?.lastName,
                dob: user?.metafields?.cult?.dob,
              },
            }
          : 0,
        session: {
          sessionId: data.sessionId,
          createdAt: new Date().getTime(),
          sessionParams: {
            deviceId: data.deviceId,
            appTenant: "cultstore",
          },
        },
        device: {
          deviceId: data.deviceId,
          createdAt: new Date().getTime(),
          deviceParams: {
            deviceId: data.deviceId,
            appTenant: "cultstore",
            appVersion: getLocalStorageValue("appVersion") ?? "",
          },
        },
        client: {
          headers: await fetch(document.URL, { method: "HEAD" })
            .then((response) => {
              let headers = {};
              for (const [key, value] of response.headers.entries()) {
                headers[key] = value;
              }
              return headers;
            })
            .catch((error) => console.error("Error fetching headers:", error)),
        },
      },
      ts_ms: new Date().getTime(),
    };
  };

  const trackDLEvent = async (eventName, event) => {
    const customData = {
      ...event.detail,
      // add more attriutes if required
    };
    
    // Sanitize data to ensure JSON-serializable (handles circular refs, newlines, etc.)
    let cleanData = customData;
    try {
      cleanData = JSON.parse(JSON.stringify(customData));
    } catch (serializationError) {
      console.error(`[DataLake] Failed to serialize ${eventName}:`, serializationError);
      console.warn('[DataLake] Problematic data:', customData);
      
      // Fallback: shallow copy to preserve primitive values
      cleanData = { ...customData };
      
      // Remove any non-primitive values that might cause issues
      Object.keys(cleanData).forEach(key => {
        const value = cleanData[key];
        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          try {
            JSON.stringify(value);
          } catch (e) {
            console.warn(`[DataLake] Removing non-serializable key: ${key}`);
            delete cleanData[key];
          }
        }
      });
    }
    
    const data = await getDataLakeCommonDetails(eventName, cleanData);
    Shopify.analytics.publish("DL_EVENTS", data);
  };

  //PAGE_VIEW
  document.addEventListener("PAGE_VIEW", async (event) => {
    await trackDLEvent("PAGE_VIEW", event);
  });

  //PDP_VIEW
  document.addEventListener("PDP_VIEW", async (event) => {
    await trackDLEvent("PDP_VIEW", event);
  });

  // Subscribe to BUTTON_CLICK event
  document.addEventListener("BUTTON_CLICK", async (event) => {
    await trackDLEvent("BUTTON_CLICK", event);
  });

  // Subscribe to LINK_CLICK event
  document.addEventListener("LINK_CLICK", async (event) => {
    await trackDLEvent("LINK_CLICK", event);
  });

  // Subscribe to APPLY_SORT event
  document.addEventListener("APPLY_SORT", async (event) => {
    await trackDLEvent("APPLY_SORT", event);
  });

  // Subscribe to APPLY_FILTER event
  document.addEventListener("APPLY_FILTER", async (event) => {
    await trackDLEvent("APPLY_FILTER", event);
  });

  // Subscribe to CHECKOUT_CLICKED event
  document.addEventListener("CHECKOUT_CLICKED", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CHECKOUT_CLICKED", event);
  });

  // Subscribe to LOGIN_INITIATED event
  document.addEventListener("LOGIN_INITIATED", async (event) => {
    await trackDLEvent("LOGIN_INITIATED", event);
  });

  // Subscribe to LOGIN_STARTED event
  document.addEventListener("LOGIN_STARTED", async (event) => {
    await trackDLEvent("LOGIN_STARTED", event);
  });

  // Subscribe to OTP_SUBMITTED event
  document.addEventListener("OTP_SUBMITTED", async (event) => {
    await trackDLEvent("OTP_SUBMITTED", event);
  });

  // Subscribe to LOGIN_COMPLETED event
  document.addEventListener("LOGIN_COMPLETED", async (event) => {
    await trackDLEvent("LOGIN_COMPLETED", event);
  });

  // Subscribe to SEARCH event
  document.addEventListener("SEARCH", async (event) => {
    await trackDLEvent("SEARCH", event);
  });

  // Subscribe to VARIANT_SELECTED event
  document.addEventListener("VARIANT_SELECTED", async (event) => {
    if (!event.detail.selectedVariant) {
      return;
    }
    event.detail.productSku = event.detail.selectedVariant.sku;
    event.detail.productName = event.detail.selectedVariant.name;
    event.detail.price = event.detail.selectedVariant.price;
    event.detail.compare_at_price =
      event.detail.selectedVariant.compare_at_price;
    event.detail.featured_image = event.detail.product.featured_image.src;

    await trackDLEvent("VARIANT_SELECTED", event);
  });

  // Subscribe to ATC (Add To Cart) event
  document.addEventListener("ATC", async (event) => {
    if (!event.detail.items?.length) {
      return;
    }
    const firstItem = event.detail.items?.[0];
    if (event.detail.selectedVariant) {
      event.detail.productSku = event.detail.selectedVariant.sku;
      event.detail.productName = event.detail.selectedVariant.name;
      event.detail.price = event.detail.selectedVariant.price;
      event.detail.compare_at_price = event.detail.selectedVariant.compare_at_price;
      event.detail.featured_image = event.detail.product?.featured_image?.src;
      event.detail.productType = event.detail.product?.productType;
    } else if (firstItem) {
      event.detail.productSku = firstItem.sku;
      event.detail.productName = firstItem.title;
      event.detail.price = firstItem.price;
      event.detail.productId = firstItem.productId;
      event.detail.variantId = firstItem.variantId;
    }
    await trackDLEvent("ATC", event);
  });

  // Subscribe to CART_OPEN event
  document.addEventListener("CART_OPEN", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CART_OPEN", event);
  });

  // Subscribe to CART_CLOSE event
  document.addEventListener("CART_CLOSE", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CART_CLOSE", event);
  });

  // Subscribe to CART_UPDATE event
  document.addEventListener("CART_UPDATE", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CART_UPDATE", event);
  });

  // Offer applied
  document.addEventListener("OFFER_APPLIED", async (event) => {
    await trackDLEvent("OFFER_APPLIED", event);
  });

  // Offer removed
  document.addEventListener("OFFER_REMOVED", async (event) => {
    await trackDLEvent("OFFER_REMOVED", event);
  });

  document.addEventListener("checkout_completed", async (event) => {
    // Attempt to create a JSON-serializable copy of event.data.
    // Fall back to a shallow copy if serialization fails so the event still gets tracked.
    let cleanData = {};
    if (event.data && typeof event.data === "object") {
      try {
        cleanData = JSON.parse(JSON.stringify(event.data));
      } catch (serializationError) {
        console.error("Failed to serialize checkout_completed event.data:", serializationError);
        // Fallback: shallow copy to avoid mutating the original object while preserving data.
        cleanData = { ...event.data };
      }
    }

    let checkoutCompletedEventData = {
      pageUrl: window.location.href,
      previousPageUrl: document.referrer,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      userAgent: navigator.userAgent,
      ...cleanData,
    };

    await trackDLEvent("CHECKOUT_COMPLETED", { detail: checkoutCompletedEventData });
  });

  document.addEventListener("CHECKOUT_PROCESS", async (event) => {
    let { checkoutEvent, ...rest } = event.detail;
    let checkoutProcessEventData = {
      pageUrl: window.location.href,
      previousPageUrl: document.referrer,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      userAgent: navigator.userAgent,
      ...rest,
    };
    
    // Validate JSON-serializable before sending to prevent Lambda errors
    try {
      const testSerialize = JSON.parse(JSON.stringify(checkoutProcessEventData));
      await trackDLEvent(checkoutEvent, { detail: testSerialize });
    } catch (serializationError) {
      console.error('[DataLake] Invalid JSON in CHECKOUT_PROCESS:', serializationError);
      
      // Send minimal safe data
      const fallbackData = {
        pageUrl: window.location.href,
        previousPageUrl: document.referrer,
        checkoutEvent,
        error: 'serialization_failed',
        errorMessage: serializationError.message,
      };
      await trackDLEvent(checkoutEvent, { detail: fallbackData });
    }
  });

  document.addEventListener("LOGOUT", async (event) => {
    await trackDLEvent("LOGOUT", event);
  });
  
  // ==================== ERROR TRACKING ====================
  
  /**
   * Track error events with flattened data
   */
  document.addEventListener("ERROR_TRACKED", async (event) => {
    try {
      // Event detail already contains flattened data from event-streaming
      const flattenedErrorData = {
        ...event.detail,
      };
      
      // Ensure all data is flattened (no nested objects)
      const dlData = {};
      Object.keys(flattenedErrorData).forEach(key => {
        const value = flattenedErrorData[key];
        // Only include primitive types (string, number, boolean)
        if (typeof value !== 'object' || value === null) {
          dlData[key] = value;
        } else if (typeof value === 'object' && !Array.isArray(value)) {
          // Flatten nested objects by prefixing keys
          Object.keys(value).forEach(nestedKey => {
            if (typeof value[nestedKey] !== 'object') {
              dlData[`${key}_${nestedKey}`] = value[nestedKey];
            }
          });
        } else if (Array.isArray(value)) {
          // Convert arrays to comma-separated strings
          dlData[key] = value.join(', ');
        }
      });
      
      await trackDLEvent("ERROR_TRACKED", { detail: dlData });
    } catch (err) {
      console.error('[DataLake] Error tracking error event:', err);
    }
  });
  
  /**
   * Track checkout errors
   */
  document.addEventListener("CHECKOUT_ERROR", async (event) => {
    try {
      const flattenedData = window.CultStoreSentry 
        ? window.CultStoreSentry.getFlattenedErrorData(event.detail.errorCode, event.detail)
        : event.detail;
        
      await trackDLEvent("CHECKOUT_ERROR", { detail: flattenedData });
    } catch (err) {
      console.error('[DataLake] Error tracking checkout error:', err);
    }
  });
  
  /**
   * Track login errors
   */
  document.addEventListener("LOGIN_ERROR", async (event) => {
    try {
      const flattenedData = window.CultStoreSentry 
        ? window.CultStoreSentry.getFlattenedErrorData(event.detail.errorCode, event.detail)
        : event.detail;
        
      await trackDLEvent("LOGIN_ERROR", { detail: flattenedData });
    } catch (err) {
      console.error('[DataLake] Error tracking login error:', err);
    }
  });
  
  /**
   * Track API errors
   */
  document.addEventListener("API_ERROR", async (event) => {
    try {
      const flattenedData = window.CultStoreSentry 
        ? window.CultStoreSentry.getFlattenedErrorData(event.detail.errorCode, event.detail)
        : event.detail;
        
      await trackDLEvent("API_ERROR", { detail: flattenedData });
    } catch (err) {
      console.error('[DataLake] Error tracking API error:', err);
    }
  });
  
  /**
   * Track SDK errors
   */
  document.addEventListener("SDK_ERROR", async (event) => {
    try {
      const flattenedData = window.CultStoreSentry 
        ? window.CultStoreSentry.getFlattenedErrorData(event.detail.errorCode, event.detail)
        : event.detail;
        
      await trackDLEvent("SDK_ERROR", { detail: flattenedData });
    } catch (err) {
      console.error('[DataLake] Error tracking SDK error:', err);
    }
  });
  
  /**
   * Track silent failures
   */
  document.addEventListener("SILENT_FAILURE", async (event) => {
    try {
      const flattenedData = window.CultStoreSentry 
        ? window.CultStoreSentry.getFlattenedErrorData(event.detail.errorCode, event.detail)
        : event.detail;
        
      await trackDLEvent("SILENT_FAILURE", { detail: flattenedData });
    } catch (err) {
      console.error('[DataLake] Error tracking silent failure:', err);
    }
  });
});
